import React from 'react'
import PropTypes from 'prop-types'
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar'
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton'
import EventDay from './EventDay'

const EventCalendar = ({ selectedDate, onDateChange, onMonthChange, isLoading, eventsByDay, eventStatusesByDay, sx = {} }) => {
  return (
    <DateCalendar
      value={selectedDate}
      onChange={onDateChange}
      onMonthChange={onMonthChange}
      loading={isLoading}
      renderLoading={() => <DayCalendarSkeleton />}
      slots={{
        day: EventDay,
      }}
      slotProps={{
        day: {
          eventsByDay,
          eventStatusesByDay,
        },
      }}

    />
  )
}

EventCalendar.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  onDateChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  eventsByDay: PropTypes.object,
  eventStatusesByDay: PropTypes.object,
}

export default EventCalendar
